<template>
  <div class="hello">
    <h2 v-if="staticTitle">{{staticTitle}}</h2>
    <p></p><hr/>
  </div>
</template>

<script>
import db from '../../../lib/db'
export default {
  name: 'Titles',
  props: {
    showId: String,
    staticTitle: String
  },
    data () {
        return {
            fetchedTitle: null  
        }
    },
    methods: {
        getTitle: function () {
            console.log('the show id ', this.showId)
            if(this.showId){
            return db.getRef().ref('show').child(this.showId).once('value').then((snapshot) => {
                console.log('title snap ', snapshot.exists())
                this.fetchedTitle = snapshot.child('title').val()
                return snapshot.child('title').val()
            })
            }
        }
    },
    created () {
        // this.getTitle()
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
